import React, {Component} from 'react';
import './global.css';
import NavBar from './NavBar';
import PageFooter from './PageFooter';

let _this;

class FAQ extends Component {
    constructor(props, context) {
        super(props, context);
        _this = this;

    }

    componentDidMount() {
        // setCurrentScreen(analytics, window.location.pathname);
        // logEvent(analytics, 'screen_view')
    }


    render() {
        return <div className="container">
            <NavBar navigate={this.props.navigate} current='FAQ' />
            <br/>
            <p className="normal">
                <h1>Frequently asked questions</h1>
            </p>
            <div className="card" id="shellWhite">
                <div id="content">
                    <p className="normal">
                        <h2>1. Can I record a conference call or a meeting?</h2>
                    </p>
                    <p>
                        Yes, if the meeting has the dial-in option! Dial in the meeting, press the ‘Merge And Record’
                        button on the A Call Recorder home screen, answer the callback call, and use the phone's 'Merge'
                        button to merge those lines. For more details, go to the <a href="#guide"
                                                                                    role="button"
                                                                                    onClick={() => _this.props.navigate('UserGuide')}>Tutorial</a>.
                    </p>
                </div>
            </div>
            <br/>
            <div className="card" id="shellWhite">
                <div id="content">
                    <p className="normal">
                        <h2>2. Can I record a call conversation with the caller or callee outside Canada or US?</h2>
                    </p>
                    <p>
                        Unfortunately, you can’t choose the ‘Call and Record’ option to call abroad right now, but we’re
                        working on an update that will let you call to and from other countries.
                    </p>
                    <p>
                        Luckily, you can always use the <b>’Merge And Record’</b> option!
                        Either way, call your foreign destination by pressing the ‘Merge And Record’ button in the app,
                        answer the callback call from A Call Recorder, and merge it with the ongoing call. Or first,
                        press the ‘Merge And Record’ button, answer the callback call and then add your foreign
                        destination to the call using your standard phone plan. For more information, go to the tutorial
                        and read article 2 (Record incoming calls or merge with the ongoing call).
                    </p>
                    <p>
                        <b>Tip:</b> When using the ‘Merge And Record’ option this way, your own phone number appears
                        to the recipient as usual — the merge happens entirely through your phone’s native dialer.
                    </p>
                </div>
            </div>
            <br/>
            <div className="card" id="shellWhite">
                <div id="content">
                    <p className="normal">
                        <h2>3. What languages A Call Recorder supports, and conversations on what languages can be
                            transcribed?</h2>
                    </p>
                    <p>
                        We will record a call in any language. Transcription also works for most languages; however,
                        it has been primarily tested for the most common languages in the US and Canada.
                    </p>
                </div>
            </div>
            <br/>
            <div className="card" id="shellWhite">
                <div id="content">
                    <p className="normal">
                        <h2>4. Will the person I'm calling see my phone number?</h2>
                    </p>
                    <p>
                        It depends on how you initiate the recording:
                    </p>
                    <p>
                        <b>'Call and Record' (outbound call from the app):</b> The recipient will see our service
                        number, not your personal phone number. This is a current limitation — phone number
                        passthrough is not supported for this mode yet.
                    </p>
                    <p>
                        <b>'Merge And Record':</b> Your number appears normally to the recipient. With this method,
                        you initiate the call yourself from your phone's native dialer — the app simply merges in
                        our recording line. You can also tap 'Merge And Record' first, answer our callback call, and
                        then dial the recipient yourself and merge both calls. Either way, the recipient always sees
                        your real number.
                    </p>
                    <p>
                        If showing your own number to the recipient is important, use the <b>'Merge And Record'</b>
                        option. See the <a href="#guide" role="button"
                                          onClick={() => _this.props.navigate('UserGuide')}>Tutorial</a> for
                        step-by-step instructions.
                    </p>
                </div>
            </div>
            <br/>
            <div className="card" id="shellWhite">
                <div id="content">
                    <p className="normal">
                        <h2>5. Can I record a call for free?</h2>
                    </p>
                    <p>
                        Unfortunately you can’t.
                    </p>
                </div>
            </div>
            <br/>
            <div className="card" id="shellWhite">
                <div id="content">
                    <p className="normal">
                        <h2>6. Do you offer volume discounts?</h2>
                    </p>
                    <p>
                        Please reach out to support@answersolutions.net to see if can provide a volume discount.
                    </p>
                </div>
            </div>
            <br/>
            <div className="card" id="shellWhite">
                <div id="content">
                    <p className="normal">
                        <h2>7. How fast does it take to get the recorded call audio and transcription?</h2>
                    </p>
                    <p>
                        The audio file of the recorded call is available immediately after the call ends. The
                        transcription takes around 50%-75% of the call duration to process. For example, processing a
                        20-minute call might take 10-15 minutes. Note that you need to request transcription through the
                        app manually.
                    </p>
                </div>
            </div>
            <br/>
            <div className="card" id="shellWhite">
                <div id="content">
                    <p className="normal">
                        <h2>8. How does billing work?</h2>
                    </p>
                    <p>
                        Once you download the app, you receive <strong>60 minutes in credit</strong>. Your account's
                        funds will be drained as you record the calls in the app or you request the transcription of
                        recorded calls. <strong>60 Credit Minutes</strong> is enough to record 15 minutes of a call
                        phone conversation, and then you can use the rest of the credit to transcribe this recording
                        (Transcribing 15 minutes of audio costs 15 * 3 = 45 credit minutes). Of course, you can spend
                        the entire 60 minutes recording the phone calls.
                    </p>
                    <p>
                        You can purchase extra credit minutes - once your account balance has dropped below the number
                        of credit minutes, you need to record the next call or transcribe a previously recorded
                        conversation.
                    </p>
                    <p><span className="crimson_text">For more information got to <a href="#price"
                                                                                     role="button"
                                                                                     onClick={() => _this.props.navigate('Pricing')}>Pricing</a> page!</span>
                    </p>
                </div>
            </div>
            <br/>
            <div className="card" id="shellWhite">
                <div id="content">
                    <p className="normal">
                        <h2>9. How can I talk to someone if I want to give a feedback or suggestion?</h2>
                    </p>
                    <p>
                        Feel free to email us at feedback@answersolutions.net
                    </p>
                </div>
            </div>
            <br/>
            <div className="card" id="shellWhite">
                <div id="content">
                    <p className="normal">
                        <h2>10. What happens to my recordings if I delete my account?</h2>
                    </p>
                    <p>
                        When you delete your account, all your recorded audio files and transcriptions are permanently
                        deleted from our cloud. This action cannot be undone. Before deleting your account, use the
                        <b> Share</b> feature to email yourself any recordings or transcriptions you want to keep.
                    </p>
                </div>
            </div>
            <br/>
            <div className="card" id="shellWhite">
                <div id="content">
                    <p className="normal">
                        <h2>11. Does A Call Recorder work on both iPhone and Android?</h2>
                    </p>
                    <p>
                        Yes. The app is available for both iOS (iPhone) and Android. The recording technique is the
                        same on both platforms — our server calls you back and merges the lines. The app interface and
                        steps are nearly identical on both operating systems.
                    </p>
                </div>
            </div>
            <br/>
            <div className="card" id="shellWhite">
                <div id="content">
                    <p className="normal">
                        <h2>12. Is there a subscription, or is it pay-as-you-go?</h2>
                    </p>
                    <p>
                        Strictly pay-as-you-go — <strong>no subscription, no recurring charges</strong>. You start
                        with 60 free credit minutes. When your balance runs low, you purchase additional credit
                        minutes in the app only when you need them. Your purchased credits never expire.
                    </p>
                </div>
            </div>
            <br/>
            <div className="card" id="shellWhite">
                <div id="content">
                    <p className="normal">
                        <h2>13. What happens if my credits run out during a call?</h2>
                    </p>
                    <p>
                        The call continues normally — you will not be disconnected mid-conversation. However, our
                        server will stop recording once your balance reaches zero. The audio recorded up to that point
                        is saved and available in your <b>Recorded Calls</b> list. You will need to top up your
                        balance before starting the next recording session.
                    </p>
                </div>
            </div>
            <br/>
            <PageFooter navigate={this.props.navigate} current='FAQ' />
            <br/>
        </div>
    }
}

export default FAQ;